var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"margin":"0 auto","height":"100vh","border":"0","width":"100%","display":"flex","position":"absolute","left":"0","top":"0"},attrs:{"src":_vm.iframeURL}})}
var staticRenderFns = []

export { render, staticRenderFns }